<template>
    <div>
        <el-card shadow="hover">
            <el-row>
                <el-col :span="8">
                    姓名：
                    <el-input
                        type="text"
                        class="search"
                        clearable
                        v-model="list.name"
                    ></el-input>
                </el-col>
                <el-col :span="8">
                    学号：
                    <el-input
                        type="text"
                        class="search"
                        clearable
                        v-model="list.personalId"
                    ></el-input>
                </el-col>
                <el-col :span="8">
                    <el-button
                        icon="el-icon-search"
                        style="float: right"
                        type="primary"
                        @click="getAdminList"
                        >搜索</el-button
                    >
                </el-col>
            </el-row>
        </el-card>
        <br />
        <el-card shadow="hover">
            <el-table v-loading="list.loading" :data="list.data">
                <el-table-column prop="name" label="姓名"></el-table-column>
                <el-table-column
                    prop="personal_id"
                    label="学号/工号"
                ></el-table-column>
                <!-- <el-table-column prop="type" label="角色">
                    <template slot-scope="scope">
                        <span v-if="scope.row.type == 0">学生</span>
                        <span v-else-if="scope.row.type == 1">老师</span>
                        <span v-else-if="scope.row.type == 9">超级管理员</span>
                    </template>
                </el-table-column> -->
                <!-- <el-table-column prop="email" label="校内/校外">
                    <template slot-scope="scope">
                        <span v-if="scope.row.email">校外</span>
                        <span v-else>校内</span>
                    </template>
                </el-table-column> -->
                <el-table-column label="操作" min-width="160">
                    <template slot-scope="scope">
                        <el-button
                            size="mini"
                            @click="
                                handleInsertOrUpdate(scope.$index, scope.row)
                            "
                        >
                            修改
                        </el-button>
                        <el-button
                            size="mini"
                            type="danger"
                            @click="handleDelete(scope.$index, scope.row)"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <br />
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="list.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="list.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="list.total"
            >
            </el-pagination>
        </el-card>

        <el-dialog :visible.sync="dialog.visible" title="修改">
            <el-select
                v-model="dialog.data.college"
                size="mini"
                placeholder="请选择学院"
                @change="handleCollegeChange"
            >
                <el-option
                    v-for="item in college"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                ></el-option>
            </el-select>
            <!-- <el-select
                v-if="dialog.data.lab == 2"
                v-model="dialog.data.laboratory"
                filterable
                size="mini"
                placeholder="请选择实验室"
                style="margin-left: 10px"
                v-loading="labLoading"
            >
                <el-option
                    v-for="item in lab"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                ></el-option>
            </el-select> -->
            <el-divider content-position="left"
                >虚拟仿真实验教学平台</el-divider
            >
            <el-radio-group v-model="dialog.data.manager">
                <el-radio :label="1">学生</el-radio>
                <el-radio :label="2">教师</el-radio>
                <el-radio :label="3">校级管理员</el-radio>
                <el-radio :label="4">管理员</el-radio> 
            </el-radio-group>
            <el-divider content-position="left">真实项目案例库</el-divider>
            <el-radio-group v-model="dialog.data.lab">
                <el-radio :label="1">学生</el-radio>
                <el-radio :label="2">教师</el-radio>
                <el-radio :label="3">学院管理员</el-radio>
                <el-radio :label="4">校级管理员</el-radio>
                <el-radio :label="5">管理员</el-radio>
            </el-radio-group>
            <el-divider content-position="left">实践教育基地管理</el-divider>
            <el-radio-group v-model="dialog.data.base">
                <el-radio :label="1">学生</el-radio>
                <el-radio :label="2">管理员</el-radio>
            </el-radio-group>
            <br /><br />
            <div class="dialogSubmit">
                <el-button type="primary" @click="submit">提交</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    selectAdmin,
    deleteAdmin,
    updateAdminAuth,
    getCollegeList,
    getLaboratoryList
} from "@/api/views/manager/admin";

export default {
    name: "Admin",
    data() {
        return {
            college: [],
            lab: [],
            labLoading: true,
            list: {
                page: 1,
                size: 10,
                total: 0,
                data: [],
                loading: true,
                name: null,
                personalId: null
            },

            // 弹出层
            dialog: {
                id: 0,
                visible: false,
                title: "",
                data: {
                    manager: 1,
                    lab: 1,
                    base: 1,
                    college: "1",
                    laboratory: null
                }
            }
        };
    },
    created() {
        getCollegeList().then(res => {
            this.college = res.data;
        });
        getLaboratoryList({
            college: 1
        }).then(res => {
            this.lab = res.data;
            this.labLoading = false;
        });
        this.getAdminList();
    },
    methods: {
        handleSizeChange(size) {
            this.list.size = size;
            this.getAdminList();
        },
        handleCurrentChange(page) {
            this.list.page = page;
            this.getAdminList();
        },
        handleCollegeChange() {
            this.labLoading = true;
            getLaboratoryList({
                college: this.dialog.data.college
            }).then(res => {
                this.lab = res.data;
                this.labLoading = false;
            });
        },
        // 获取管理员列表
        getAdminList() {
            this.list.loading = true;
            selectAdmin(this.list).then(res => {
                Object.assign(this.list, res);
                this.list.total = parseInt(this.list.total);
                this.list.loading = false;
            });
        },
        // 添加或者编辑管理员
        handleInsertOrUpdate(index, row) {
            this.dialog.id = row.id;
            let isLogin = String(row.islogin).split("");
            this.dialog.data.manager = parseInt(isLogin[0]) ?? 1;
            this.dialog.data.lab = parseInt(isLogin[1]) ?? 1;
            this.dialog.data.base = parseInt(isLogin[2]) ?? 1;
            this.dialog.data.college = row.college;
            this.dialog.data.laboratory = row.laboratory;
            this.dialog.visible = true;
        },
        // 删除管理员
        handleDelete(index, row) {
            deleteAdmin({
                id: row.id
            }).then(() => {
                this.getAdminList();
            });
        },
        // 提交修改
        submit() {
            if(isNaN(this.dialog.data.manager) || isNaN(this.dialog.data.lab) ||isNaN(this.dialog.data.base)){
        
                this.$message.error("请设置全部权限");
                return;
            }
            let isLogin =
                this.dialog.data.manager +
                "" +
                (this.dialog.data.lab + "") +
                (this.dialog.data.base + "");
            updateAdminAuth({
                id: this.dialog.id,
                isLogin: isLogin,
                college: this.dialog.data.college,
                laboratory: this.dialog.data.laboratory
             
            }).then((response) => {

                if (response.code === 1) {
                    // 提示保存成功
                    this.$message.success("保存成功");
                    this.dialog.visible = false;
                    this.getAdminList();
                    } else {
                        // 如果返回的 code 不是 1，提示错误信息（如果有）
                        this.$message.error(response.message || "保存失败");
                    }   

            });
        }
    }
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__body {
    padding: 10px 20px 30px 20px;
}

.dialogSubmit {
    width: 100%;
    text-align: right;

    .el-button {
        width: 100px;
    }
}

.search {
    width: calc(100% - 100px);
}
</style>
